module.exports = require('./Loadmore');



// WEBPACK FOOTER //
// ./lib/components/loadmore/index.js